import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import device from '../../utilitarios/device';
import { getDevice } from './utilApi';

export function generarInicioMAC() {
    let params = {};
    params.url = "login/GenerarInicioMac";
    params.data = {};
    console.log("params.data==>", params.data);
    return ServiceManager.prototype.Post(params);
}

export function generarMAC({ CorreoElectronico, SO, Browser }) {
    let params = {};
    params.url = "login/generarmac";
    params.data = {
        'dto.CorreoElectronico': CorreoElectronico,
        'dto.Descripcion': `${SO} / ${Browser}`,
        'dto.Sistema': data.Sistema
    };
    console.log("params.data==>", params.data);
    return ServiceManager.prototype.Post(params);
}

export function login({ CorreoElectronico, Contrasenia }) {
    const DispositivoId = getDevice();
    console.log("DispositivoId : ",DispositivoId)
    let params = {};
    params.url = "login/login";
    params.data = {
        'dto.CorreoElectronico': CorreoElectronico,
        'dto.Contrasenia': Contrasenia,
        'dto.CodigoDispositivo': DispositivoId,
        'dto.Sistema': data.Sistema,
        'dto.Os': 'android'
    };
    return ServiceManager.prototype.Post(params);
}

export function validuserlogin({ CorreoElectronico ,descripcion}) {
    const DispositivoId = getDevice();
    console.log("DispositivoId validuserlogin : ",DispositivoId)
    console.log("descripcion : ",descripcion)
    let params = {};
    params.url = "login/validalogin";
    params.data = {
        'dto.CorreoElectronico': CorreoElectronico,
        'dto.CodigoDispositivo': DispositivoId,
        'dto.Descripcion': descripcion,
        'dto.Sistema': data.Sistema
    };
    console.log("params.data==>", params.data);
    return ServiceManager.prototype.Post(params);
}

export function getRazonSocialAsociados(dealer, linea) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarRazonSocial";
    params.data = {
        'dto.CodigoDealer': dealer.originalcodcliente,
        'dto.Vkorg': linea.vkorg,
        'dto.DispositivoDealer': dealer.codigoDispositivo,
        'dto.CorreoElectronicoDealer': dealer.correoElectronico,
        'dto.Canal': linea.canal,
        'dto.Sector': linea.sector,
        'dto.Sistema': data.Sistema
    };

    return ServiceManager.prototype.Post(params);
}
export function ListarLocalesServicio(dealer, linea) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarLocalesServicio";
    params.data = {
        'dto.CodigoDealer': dealer.codcliente,
        'dto.CorreoElectronicoDealer': dealer.correoElectronico,
        'dto.Sistema': data.Sistema
    };
    console.log("ListarLocalesServicio===>", dealer, params.data);
    return ServiceManager.prototype.Post(params);
}
export function solicitarAcceso(CorreoElectronico, Ruc, Celular) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "login/solicitaracceso";
    params.data = {
        'dto.CorreoElectronico': CorreoElectronico,
        'dto.CodigoDispositivo': DispositivoId,
        'dto.Sistema': data.Sistema,
        'dto.Ruc': Ruc,
        'dto.Celular': Celular
    };
    console.log("Params", params);
    return ServiceManager.prototype.Post(params);
}
export function getTyC() {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "login/tyc";
    return ServiceManager.prototype.Post(params);
}
export function solicitarNuevoCodigo(CorreoElectronico) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "login/SolicitarNuevoCodigo";
    params.data = {
        'dto.CorreoElectronico': CorreoElectronico,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}
export function recuperarAcceso(CorreoElectronico) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "login/RecuperarAcceso";
    params.data = {
        'dto.CorreoElectronico': CorreoElectronico,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}
export function validarCodigoAcceso(CorreoElectronico, CodigoVerificacion) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "login/ValidarCodigoAcceso";
    params.data = {
        'dto.CorreoElectronico': CorreoElectronico,
        'dto.CodigoActivacion': CodigoVerificacion,
        'dto.Sistema': data.Sistema
    };
    console.log("params.data===>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function activarAcceso(CorreoElectronico, Contrasenia, CodigoActivacion) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "login/ActivarAcceso";
    params.data = {
        'dto.CorreoElectronico': CorreoElectronico,
        'dto.Contrasenia': Contrasenia,
        'dto.CodigoDispositivo': DispositivoId,
        'dto.CodigoActivacion': CodigoActivacion,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}

export function cambiarContrasenia(CorreoElectronico, Contrasenia, DispositivoDealer, CodigoDealer) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "login/CambiarContrasenia";
    params.data = {
        'dto.CorreoElectronico': CorreoElectronico,
        'dto.Contrasenia': Contrasenia,
        'dto.DispositivoDealer': DispositivoDealer,
        'dto.CodigoDealer': CodigoDealer,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}

export function RegistrarSugerencia(entidad  ) {    
 
    const DispositivoId = getDevice(); 
    let params = {};
    params.url = "vehiculo/RegistrarSugerencia";
    params.data = {
        'dto.CorreoElectronicoDealer': entidad.correoElectronico ,    
        'dto.CodigoDealer':  entidad.codcliente,
        'dto.PerfilCodigo': data.PerfilLinea.Repuestos  ,
        'dto.Linea': data.LineaRepuestos  ,
        'dto.Mensaje':  entidad.mensaje  ,    
        'dto.Sistema': data.Sistema  ,
        'dto.DispositivoDealer': DispositivoId,  
        'dto.Alias': data.AliasSugerencia
    }; 
    console.log("params.data====>",params.data);   
    return ServiceManager.prototype.Post(params);
}